import { render, staticRenderFns } from "./BusinessCustomerSwitch.vue?vue&type=template&id=625e4dbd&"
import script from "./BusinessCustomerSwitch.vue?vue&type=script&lang=js&"
export * from "./BusinessCustomerSwitch.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports